var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Autocomplete, LinearProgress, styled } from "@mui/material";
import { t } from "i18next";
// import mixpanel from "mixpanel-browser";
import moment from "moment";
import React from "react";
import { Get, Post } from "../api/api";
import { envConfig } from "../api/config";
import { createUILogURL, GetStepsDetailsAPIURL, VIStepsAPIURL } from "../api/url";
import { Analytics, EContactType, ESectionAttributeValue, LOCAL_STORAGE_KEYS, mixPanelEventConstants, StepsAPIBody } from "../constants";
import { useAppSelector } from "../store/hooks";
import { getLocalStorageItem } from "./storageHelper";
import dayjs from "dayjs";
import { Capacitor } from "@capacitor/core";
export var ERROR = {
    isValidFieldMgs: "Enter Valid ",
    isRequiredFieldMgs: " is Required."
};
export var maxDays = 30;
export var validateAppointmentMessageCode = "SAE003";
export var isValidField = function (field) {
    return "".concat(ERROR.isValidFieldMgs, " ").concat(field);
};
export var isRequiredField = function (field) {
    return "".concat(field, " ").concat(ERROR.isRequiredFieldMgs);
};
export var dateFormate = function (date) {
    if (date) {
        if (typeof date === 'string') {
            date = date.replace(/ /g, "T");
        }
        var originalDate = new Date(date);
        var day = originalDate.getDate();
        var month = new Intl.DateTimeFormat('en', {
            month: 'short'
        }).format(originalDate);
        var year = originalDate.getFullYear();
        // Format the date as "21 Sept, 2023"
        return "".concat(day, " ").concat(month, ", ").concat(year);
    }
    else {
        return "-";
    }
};
export var profiledateFormate = function (date) {
    if (typeof date === 'string') {
        date = date.replace(/ /g, "T");
    }
    var originalDate = new Date(date);
    var day = originalDate.getDate();
    var month = new Intl.DateTimeFormat('en', {
        month: 'short'
    }).format(originalDate);
    var year = originalDate.getFullYear();
    // Format the date as "21 Sept, 2023"
    return "".concat(month, ", ").concat(year);
};
export var getTime = function (data) {
    var date = new Date(data);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    // Convert 24-hour format to 12-hour format
    var hours12 = hours > 12 ? hours - 12 : hours;
    // Add leading zeros to single-digit minutes
    var formattedMinutes = minutes < 10 ? "0".concat(minutes) : minutes;
    return "".concat(hours12, ":").concat(formattedMinutes, " ").concat(ampm);
};
export var getTimeString = function (timeString) {
    var timeSplitArray = timeString.split(':');
    var hours = timeSplitArray[0] ? Number(timeSplitArray[0]) : '';
    var minutes = timeSplitArray[1] ? String(timeSplitArray[1]) : '';
    var result = '';
    if (hours !== '' && minutes !== '') {
        result = "".concat(hours === 0 ? '00' : hours, ":").concat(minutes, " AM");
        if (hours > 12) {
            result = "".concat(hours - 12, ":").concat(minutes, " PM");
        }
    }
    return result;
};
export var getTimeInHMS = function (minutes) {
    // Convert total minutes into hours, minutes, and seconds
    var hours = Math.floor(minutes / 60);
    var remainingMinutes = Math.floor(minutes % 60);
    var seconds = Math.round(minutes % 1 * 60); // Extract remaining seconds
    // Format the output to HH:MM:SS (add leading zeros where necessary)
    var formattedHours = hours < 10 ? "0".concat(hours) : hours;
    var formattedMinutes = remainingMinutes < 10 ? "0".concat(remainingMinutes) : remainingMinutes;
    var formattedSeconds = seconds < 10 ? "0".concat(seconds) : seconds;
    return "".concat(formattedHours, ":").concat(formattedMinutes, ":").concat(formattedSeconds);
};
export var handleMobileNoPhoneCall = function (phoneNumber) {
    window.location.href = "tel:".concat(phoneNumber);
};
export var formatTime = function (seconds) {
    var minutes = Math.floor(seconds / 60);
    var remainingSeconds = seconds % 60;
    var formattedMinutes = String(minutes).padStart(2, '0');
    var formattedSeconds = String(remainingSeconds).padStart(2, '0');
    return "".concat(formattedMinutes, ":").concat(formattedSeconds);
};
export var getTransalteToJobListItem = function (result) {
    var groupedKeys = result.reduce(function (groupedData, item, index) {
        if (!groupedData[item.ComplaintGroupName]) {
            groupedData[item.ComplaintGroupName] = {
                name: item.ComplaintGroupName,
                items: [],
                value: (index + 1).toString()
            };
        }
        groupedData[item.ComplaintGroupName].items.push(item);
        return groupedData;
    }, {});
    var groupedArray = Object.values(groupedKeys);
    return groupedArray;
};
var formatErrors = function (_data, url, requestBody) {
    var code = _data.code, error = _data.error;
    var finalMessage = '';
    if (_data.statusCode === 408) {
        var err = new Error("Request Timeout: ".concat(url));
        return t("Time out");
    }
    else if (_data.statusCode === 429) {
        return _data !== null && _data !== void 0 && _data.Time ? t("Maximum 3 OTP retry limit reached. Please wait ".concat(formatDuration(_data === null || _data === void 0 ? void 0 : _data.Time))) : t("Maximum 3 OTP retry limit reached. Please try again after some time.");
    }
    else if (_data.code == "ERR_NETWORK" || (_data === null || _data === void 0 ? void 0 : _data.message) == "Network Error") {
        var err = new Error("Network Error: ".concat(url));
        return t("It looks like you're offline. Please check your internet connection and try again.");
    }
    else if (_data.code == "ECONNABORTED") {
        var err = new Error("Request Timeout: ".concat(url));
        return t("Time out");
    }
    if (_data !== null && _data !== void 0 && _data.errorCode)
        return _data === null || _data === void 0 ? void 0 : _data.errorCode;
    if (_data !== null && _data !== void 0 && _data.message)
        return _data === null || _data === void 0 ? void 0 : _data.message;
    if (code === "PAYLOADVALERR") {
        var _error$;
        var firstError = error === null || error === void 0 || (_error$ = error[0]) === null || _error$ === void 0 ? void 0 : _error$[0];
        if (firstError) {
            var message = firstError.message, keyword = firstError.keyword, instancePath = firstError.instancePath;
            switch (keyword) {
                case "required":
                    finalMessage = message;
                    break;
                case "errorMessage":
                    var field = instancePath.replace(/\\|\//g, ' ');
                    finalMessage = "".concat(message);
                    break;
                case "type":
                    var _field = instancePath.replace(/\\|\//g, ' ');
                    finalMessage = "".concat(message);
                    break;
                default:
                    console.log('default');
                    break;
            }
        }
        return finalMessage;
    }
};
export var handleServerSideErrors = function (_data, url, requestBody) {
    if (_data) {
        createUILog({
            "Body": _objectSpread(_objectSpread({}, requestBody), {}, {
                "URL": url
            }),
            "Response": _data
        });
        return formatErrors(_data, url, requestBody);
    }
};
export var handleServerSideErrorsForAnalytics = function (_data, url, requestBody) {
    if (_data) {
        return formatErrors(_data, url, requestBody);
    }
};
export var CallStepsAPIFun = function (VIId, stepName) { return __awaiter(void 0, void 0, void 0, function () {
    var savedSteps, updatedStepsAPIBody, getStepsRequestBody, savedStepsResponse, _savedStepsResponse$d, requestBody, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                savedSteps = [];
                updatedStepsAPIBody = [];
                getStepsRequestBody = {
                    InspectionId: VIId
                };
                return [4 /*yield*/, Get("".concat(GetStepsDetailsAPIURL), {
                        params: getStepsRequestBody
                    })];
            case 1:
                savedStepsResponse = _a.sent();
                if (savedStepsResponse.success && savedStepsResponse.data) {
                    savedSteps = (_savedStepsResponse$d = savedStepsResponse.data.Steps) !== null && _savedStepsResponse$d !== void 0 ? _savedStepsResponse$d : [];
                }
                if (savedSteps && savedSteps.length > 0) {
                    updatedStepsAPIBody = savedSteps.map(function (step) {
                        if (step.Name === stepName) {
                            return _objectSpread(_objectSpread({}, step), {}, {
                                IsCompleted: true
                            });
                        }
                        return step;
                    });
                }
                else {
                    updatedStepsAPIBody = StepsAPIBody.map(function (step) {
                        if (step.Name === stepName) {
                            return _objectSpread(_objectSpread({}, step), {}, {
                                IsCompleted: true
                            });
                        }
                        return step;
                    });
                }
                requestBody = {
                    InspectionId: VIId,
                    Steps: updatedStepsAPIBody
                };
                return [4 /*yield*/, Post(VIStepsAPIURL, requestBody)];
            case 2:
                response = _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var timeStringToMilliseconds = function (timeString) {
    var _a = timeString.split(':').map(Number), hours = _a[0], minutes = _a[1], seconds = _a[2];
    return hours * 3600000 + minutes * 60000;
};
export var getSlotDisable = function (slotTime, slotDay, AvailabilityCount) {
    // debugger
    if (AvailabilityCount === 0) {
        return true;
    }
    var todayDate = new Date();
    var selectedSlotDay = new Date(slotDay);
    var isDayToday = selectedSlotDay.getDate() === todayDate.getDate() && selectedSlotDay.getMonth() === todayDate.getMonth() && selectedSlotDay.getFullYear() === todayDate.getFullYear();
    if (isDayToday) {
        if (moment(new Date(slotTime)).isSameOrBefore(moment(new Date()))) {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
};
export var getCTAList = function (object, module) {
    var isWorkshop = object === null || object === void 0 ? void 0 : object.find(function (fun) { return fun.Name === "Workshop"; });
    if (isWorkshop) {
        var menusArray = isWorkshop.Menus;
        var menu = menusArray.find(function (menu) { return menu.Name === module; });
        return menu === null || menu === void 0 ? void 0 : menu.Features;
    }
    return [];
};
export var scrollToTop = function () {
    window.scrollTo(0, 0);
};
var audioBufferToWav = function (buffer) {
    var numChannels = buffer.numberOfChannels;
    var sampleRate = buffer.sampleRate;
    var numFrames = buffer.length;
    var bytesPerSample = 2;
    var blockAlign = numChannels * bytesPerSample;
    var byteRate = sampleRate * blockAlign;
    var wavBuffer = new ArrayBuffer(44 + numFrames * blockAlign);
    var dataView = new DataView(wavBuffer);
    dataView.setUint32(0, 0x52494646);
    dataView.setUint32(4, 36 + numFrames * blockAlign, true);
    dataView.setUint32(8, 0x57415645);
    dataView.setUint32(12, 0x666d7420);
    dataView.setUint32(16, 16, true);
    dataView.setUint16(20, 1, true);
    dataView.setUint16(22, numChannels, true);
    dataView.setUint32(24, sampleRate, true);
    dataView.setUint32(28, byteRate, true);
    dataView.setUint16(32, blockAlign, true);
    dataView.setUint16(34, 8 * bytesPerSample, true);
    dataView.setUint32(36, 0x64617461);
    dataView.setUint32(40, numFrames * blockAlign, true);
    var channelData = new Array(numChannels);
    for (var i = 0; i < numChannels; i++) {
        channelData[i] = buffer.getChannelData(i);
    }
    var offset = 44;
    for (var i = 0; i < numFrames; i++) {
        for (var j = 0; j < numChannels; j++) {
            var sample = Math.max(-1, Math.min(1, channelData[j][i]));
            var int16Value = sample < 0 ? sample * 0x8000 : sample * 0x7fff;
            dataView.setInt16(offset, int16Value, true);
            offset += bytesPerSample;
        }
    }
    return wavBuffer;
};
export var convertBlobToWav = function (blob) { return __awaiter(void 0, void 0, void 0, function () {
    var arrayBuffer, audioContext, audioBuffer, wavBuffer;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                    var fileReader = new FileReader();
                    fileReader.onload = function () { return resolve(fileReader.result); };
                    fileReader.onerror = reject;
                    fileReader.readAsArrayBuffer(blob);
                })];
            case 1:
                arrayBuffer = _a.sent();
                audioContext = new AudioContext();
                return [4 /*yield*/, audioContext.decodeAudioData(arrayBuffer)];
            case 2:
                audioBuffer = _a.sent();
                wavBuffer = audioBufferToWav(audioBuffer);
                return [2 /*return*/, new Blob([wavBuffer], {
                        type: 'audio/wav'
                    })];
        }
    });
}); };
export var sortImagesByTimeStamp = function (imagesArray) {
    var sortedImages = imagesArray.sort(function (a, b) {
        return moment(a._ts).diff(moment(b._ts));
    });
    return sortedImages;
};
//compare minute and hours
export var minutesOfDay = function (m) {
    return m.getMinutes() + m.getHours() * 60;
};
export function dataURLtoFile(dataurl, filename) {
    var _arr$;
    var arr = dataurl.split(','), mime = (_arr$ = arr[0]) === null || _arr$ === void 0 || (_arr$ = _arr$.match(/:(.*?);/)) === null || _arr$ === void 0 ? void 0 : _arr$[1], bstr = atob(arr[arr.length - 1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {
        type: mime
    });
}
export var getCustomerVoiceSectionAttributes = function (data) {
    if (data !== null && data !== void 0 && data.ChildSections) {
        var _data$ChildSections, _data$ChildSections2, _data$ChildSections3;
        var SA_COMMENTS_SECTION = (_data$ChildSections = data.ChildSections) === null || _data$ChildSections === void 0 ? void 0 : _data$ChildSections.find(function (item) { return item.Key === "SA_COMMENTS"; });
        var OVERALL_COMMENTS_SECTION = (_data$ChildSections2 = data.ChildSections) === null || _data$ChildSections2 === void 0 ? void 0 : _data$ChildSections2.find(function (item) { return item.Key === "OVERALL_COMMENTS"; });
        var JOB_ITEMS_SECTION = (_data$ChildSections3 = data.ChildSections) === null || _data$ChildSections3 === void 0 ? void 0 : _data$ChildSections3.find(function (item) { return item.Key === "JOB_ITEMS"; });
        return {
            SA_COMMENTS_SECTION_ATTRIBUTES: SA_COMMENTS_SECTION === null || SA_COMMENTS_SECTION === void 0 ? void 0 : SA_COMMENTS_SECTION.SectionAttributes[0],
            OVERALL_COMMENTS_SECTION_ATTRIBUTES: OVERALL_COMMENTS_SECTION === null || OVERALL_COMMENTS_SECTION === void 0 ? void 0 : OVERALL_COMMENTS_SECTION.SectionAttributes[0],
            JOB_ITEMS_SECTION_ATTRIBUTES: JOB_ITEMS_SECTION === null || JOB_ITEMS_SECTION === void 0 ? void 0 : JOB_ITEMS_SECTION.SectionAttributes[0]
        };
    }
};
export var getprecheckSectionAttributes = function (data) {
    if (data !== null && data !== void 0 && data.ChildSections) {
        var _data$ChildSections4;
        var PRODUCT_CONDITION_SECTION = (_data$ChildSections4 = data.ChildSections) === null || _data$ChildSections4 === void 0 ? void 0 : _data$ChildSections4.find(function (item) { return item.Key === "PRODUCT_CONDITION"; });
        return {
            PRODUCT_CONDITION_SECTION_ATTRIBUTES: PRODUCT_CONDITION_SECTION === null || PRODUCT_CONDITION_SECTION === void 0 ? void 0 : PRODUCT_CONDITION_SECTION.SectionAttributes[0]
        };
    }
};
export var getJobItemsTranslateToJobItems = function (array) {
    var transformedArray = array === null || array === void 0 ? void 0 : array.map(function (obj) {
        var _obj$Comments;
        var ImageAttachmentsArray = [];
        if (obj !== null && obj !== void 0 && obj.images && obj.images.length >= 0) {
            obj.images.map(function (image) {
                var _image$isNewImageUplo;
                ImageAttachmentsArray.push({
                    AttachmentId: image.attachmentId,
                    MediaType: 1,
                    SystemName: "CustomerVoiceToJobItem",
                    isNewImageUploaded: (_image$isNewImageUplo = image.isNewImageUploaded) !== null && _image$isNewImageUplo !== void 0 ? _image$isNewImageUplo : false
                });
            });
        }
        else if (obj !== null && obj !== void 0 && obj.ImageAttachments && obj.ImageAttachments.length > 0) {
            obj.ImageAttachments.map(function (image) {
                if (image.MediaType == 1) {
                    ImageAttachmentsArray.push({
                        AttachmentId: image.AttachmentId,
                        MediaType: 1,
                        SystemName: "CustomerVoiceToJobItem"
                    });
                }
            });
        }
        if (obj.audioAttachmentId) {
            ImageAttachmentsArray.push({
                AttachmentId: obj.audioAttachmentId,
                MediaType: 2,
                SystemName: "CustomerVoiceToJobItem"
            });
        }
        else if (!obj.isNewAudioUploaded && !obj.isAudioDelete) {
            if (obj !== null && obj !== void 0 && obj.ImageAttachments && obj.ImageAttachments.length > 0) {
                obj.ImageAttachments.map(function (image) {
                    if (image.MediaType == 2) {
                        ImageAttachmentsArray.push({
                            AttachmentId: image.AttachmentId,
                            MediaType: 2,
                            SystemName: "CustomerVoiceToJobItem"
                        });
                    }
                });
            }
        }
        return {
            SystemName: obj.SystemName ? obj.SystemName : "CustomerVoiceToJobItem",
            ComplaintGroupAssociationId: obj.ComplaintGroupAssociationId,
            ComplaintGroupChildAssociationId: obj.ComplaintGroupChildAssociationId,
            Value: "1",
            Comments: (_obj$Comments = obj.Comments) !== null && _obj$Comments !== void 0 ? _obj$Comments : "",
            ComplaintId: obj.ComplaintId,
            ImageAttachments: ImageAttachmentsArray,
            images: obj.images,
            audioAttachmentId: obj.audioAttachmentId,
            audioDuration: obj.audioDuration,
            audioUrl: obj.audioUrl,
            ComplaintName: obj.ComplaintName,
            isNewAudioUploaded: obj.isNewAudioUploaded,
            ComplaintGroupId: obj.ComplaintGroupId
        };
    });
    return transformedArray;
};
export var createJobItemPayload = function (array) {
    var transformedArray = array === null || array === void 0 ? void 0 : array.map(function (obj) {
        var _obj$Comments2;
        var ImageAttachmentsArray = [];
        if (obj !== null && obj !== void 0 && obj.images && obj.images.length >= 0) {
            obj.images.map(function (image) {
                ImageAttachmentsArray.push({
                    AttachmentId: image.attachmentId,
                    MediaType: 1,
                    SystemName: "CustomerVoiceToJobItem"
                });
            });
        }
        else if (obj !== null && obj !== void 0 && obj.ImageAttachments && obj.ImageAttachments.length > 0) {
            obj.ImageAttachments.map(function (image) {
                if (image.MediaType == 1) {
                    ImageAttachmentsArray.push({
                        AttachmentId: image.AttachmentId,
                        MediaType: 1,
                        SystemName: "CustomerVoiceToJobItem"
                    });
                }
            });
        }
        if (obj.audioAttachmentId) {
            ImageAttachmentsArray.push({
                AttachmentId: obj.audioAttachmentId,
                MediaType: 2,
                SystemName: "CustomerVoiceToJobItem"
            });
        }
        else if (!obj.isNewAudioUploaded && !obj.isAudioDelete) {
            if (obj !== null && obj !== void 0 && obj.ImageAttachments && obj.ImageAttachments.length > 0) {
                obj.ImageAttachments.map(function (image) {
                    if (image.MediaType == 2) {
                        ImageAttachmentsArray.push({
                            AttachmentId: image.AttachmentId,
                            MediaType: 2,
                            SystemName: "CustomerVoiceToJobItem"
                        });
                    }
                });
            }
        }
        return {
            SystemName: obj.SystemName ? obj.SystemName : "CustomerVoiceToJobItem",
            ComplaintGroupAssociationId: obj.ComplaintGroupAssociationId,
            ComplaintGroupChildAssociationId: obj.ComplaintGroupChildAssociationId,
            Value: "1",
            Comments: (_obj$Comments2 = obj.Comments) !== null && _obj$Comments2 !== void 0 ? _obj$Comments2 : "",
            ComplaintId: obj.ComplaintId,
            ImageAttachments: ImageAttachmentsArray,
            ComplaintName: obj.ComplaintName,
            ComplaintAssociations: []
        };
    });
    return transformedArray;
};
export var MuiAutocomplete = styled(Autocomplete)(function (_ref) {
    var theme = _ref.theme;
    return {
        "& fieldset": {
            border: '1px solid #DEE4EB',
            boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)'
        },
        '.MuiOutlinedInput-notchedOutline': {
            borderColor: '#DEE4EB'
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #AFD5FF",
            borderRadius: "8px",
            boxShadow: "0px 0px 0px 4px rgba(54, 151, 255, 0.24), 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
        },
        '&.Mui-disabled': {
            backgroundColor: '#F4F7FA',
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#DEE4EB'
            }
        }
    };
});
export var sectionAttributeDetails = function (section) {
    var updatedList = [];
    section === null || section === void 0 || section.map(function (item) {
        var newObj = Object.assign({}, item, item.Section);
        delete newObj.Section;
        updatedList.push(_objectSpread(_objectSpread({}, newObj), {}, {
            isAccordianOpen: false
        }));
    });
    var obj = {};
    var newArray = [];
    var finalModuleSectionArray = [];
    var res = updatedList === null || updatedList === void 0 ? void 0 : updatedList.map(function (elem) {
        var newSectionAttribute = elem.SectionAttributes;
        var mergedObj = null;
        var newAttribute = newSectionAttribute.map(function (el) {
            if (el !== null && el !== void 0 && el.Key && !el.IsDeleted) {
                obj[el.Key] = el.Value === ESectionAttributeValue.ON ? true : false;
                obj[el.Key + "DefaultValue"] = el.DefaultValue === ESectionAttributeValue.ON ? true : false;
                mergedObj = _objectSpread(_objectSpread({}, el), obj);
            }
        });
        if (mergedObj) {
            newArray.push(mergedObj);
        }
        obj = {};
        delete elem.SectionAttributes;
        elem['SectionAttributes'] = [];
        newArray.forEach(function (value) {
            newSectionAttribute.forEach(function (value1) {
                if (value.id == value1.id) {
                    elem.SectionAttributes.push(value);
                }
            });
        });
        finalModuleSectionArray.push(elem);
    });
    var sortedArray = finalModuleSectionArray === null || finalModuleSectionArray === void 0 ? void 0 : finalModuleSectionArray.sort(function (a, b) { return a.Sequence - b.Sequence; });
    return sortedArray;
};
export var convertRegistrationNo = function (registrationNo) {
    // Assuming the original registration number is always in the format DL1RAA4940
    var stateCode = registrationNo === null || registrationNo === void 0 ? void 0 : registrationNo.substring(0, 2); // DL
    var districtCode = registrationNo === null || registrationNo === void 0 ? void 0 : registrationNo.substring(2, 3); // 1
    var seriesCode = registrationNo === null || registrationNo === void 0 ? void 0 : registrationNo.substring(3, 5); // RA
    var uniqueCode = registrationNo === null || registrationNo === void 0 ? void 0 : registrationNo.substring(5); // A4940
    // // Rearrange to the desired format
    var newRegistrationNo = "".concat(stateCode).concat(districtCode).concat(registrationNo === null || registrationNo === void 0 ? void 0 : registrationNo.charAt(3)).concat(seriesCode).concat(uniqueCode);
    return newRegistrationNo;
};
export var checkIfBetweenNowAndContdownTime = function (CountdownTimeInSeconds, deliveryDate) {
    var now = moment(); // Current time
    var timeAfterCountdownTimefromNow = moment().add(CountdownTimeInSeconds, 'seconds');
    return moment(deliveryDate).isBetween(now, timeAfterCountdownTimefromNow);
};
export var getAlternatePartConfigByTaskName = function (taskName, alternatePartConfigState) {
    var alternatePartConfig = alternatePartConfigState;
    var result = true;
    if (alternatePartConfig) {
        var element = alternatePartConfig.Conditions.find(function (item) { return item.Name === taskName; });
        result = !!(element && element.Value);
    }
    return result;
};
export var getSupersadeAlternatePartMessage = function (alternatePartName, originalPartName) {
    return "Supersede ".concat(alternatePartName, " replaced for ").concat(originalPartName);
};
export var isLoadingState = function (keys) {
    if (!keys)
        return;
    var crud = useAppSelector(function (state) { return state.crud; });
    return keys === null || keys === void 0 ? void 0 : keys.some(function (key) { return (crud === null || crud === void 0 ? void 0 : crud["isLoading".concat(key)]) === "loading"; });
};
export var isLoaderActive = function (keys) {
    if (!keys)
        return null;
    var crud = useAppSelector(function (state) { return state.crud; });
    if (keys !== null && keys !== void 0 && keys.some(function (key) { return (crud === null || crud === void 0 ? void 0 : crud["isLoading".concat(key)]) === "loading"; }))
        return /*#__PURE__*/ React.createElement(LinearProgress, {
            sx: {
                mt: 0.6
            }
        });
    return null;
};
export var getColor = function (name) {
    switch (name) {
        case 'High':
            return '#F5222D';
        case 'Medium':
            return '#FFAB00';
        case 'Low':
            return '#52C41A';
        default:
            return null;
    }
};
export var getBackgroundColor = function (name) {
    switch (name) {
        case 'High':
            return '#FFF1F0';
        case 'Medium':
            return '#FFF7E5';
        case 'Low':
            return '#F6FFED';
        default:
            return null;
    }
};
export var getMediaType = function (type) {
    var mediaType = type === null || type === void 0 ? void 0 : type.split('/')[0];
    switch (mediaType) {
        case 'image':
            return 1;
        case 'audio':
            return 2;
        case 'video':
            return 3;
        case 'application':
            return 4;
        case 'text':
            return 5;
        default:
            return 0;
    }
};
export var formatDate = function (dateString) {
    var date = new Date(dateString);
    var day = date.toLocaleString('en-US', {
        day: '2-digit'
    });
    var month = date.toLocaleString('en-US', {
        month: 'short'
    });
    var year = date.toLocaleString('en-US', {
        year: 'numeric'
    });
    var time = date.toLocaleString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
    return "".concat(day, " ").concat(month, ", ").concat(year, " ").concat(time);
};
// Format:
// console.log(formatDate('2024-10-24T10:48:00.000Z')); // "24 Oct, 2024, 10:48 AM"
var formatResponseTime = function (ms) {
    var minutes = Math.floor(ms / 60000); // Convert to minutes
    var seconds = Math.floor(ms % 60000 / 1000); // Convert remainder to seconds
    var milliseconds = ms % 1000; // Get the remaining milliseconds
    return "".concat(minutes, "m ").concat(seconds, "s ").concat(milliseconds, "ms");
};
function parseTime(timeString) {
    var match = timeString.match(/(\d+)m\s(\d+)s\s(\d+)ms/);
    if (!match)
        throw new Error("Invalid time format");
    var _a = match.map(Number), minutes = _a[1], seconds = _a[2], milliseconds = _a[3];
    return minutes * 60000 + seconds * 1000 + milliseconds;
}
export var GoogleAnlyticsErrorLog = function (profileData, url, msg, request, traceId) {
    var relativeUrl = url === null || url === void 0 ? void 0 : url.replace(envConfig().baseURL, '');
    var _request = request && JSON.parse(JSON.stringify(request));
    if (Analytics.GA) {
        var _profileData$data, _profileData$data2, _profileData$data3, _profileData$data4;
        window.gtag('event', "Errors" + " ".concat(profileData === null || profileData === void 0 || (_profileData$data = profileData.data) === null || _profileData$data === void 0 ? void 0 : _profileData$data.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data2 = profileData.data) === null || _profileData$data2 === void 0 ? void 0 : _profileData$data2.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data3 = profileData.data) === null || _profileData$data3 === void 0 ? void 0 : _profileData$data3.IdentityId), {
            'id': profileData === null || profileData === void 0 || (_profileData$data4 = profileData.data) === null || _profileData$data4 === void 0 ? void 0 : _profileData$data4.IdentityId,
            // Transaction ID.
            'date': new Date(),
            'path': "".concat(window.location.href),
            'url': relativeUrl !== null && relativeUrl !== void 0 ? relativeUrl : "",
            'url error Message': relativeUrl + " Error Message : ".concat(msg) + " Request : ".concat(JSON.stringify(request)),
            'traceId': traceId || ""
        });
    }
    if (Analytics.MixPanel) {
        if (mixPanelEventConstants.ErrorLogEvents) {
            if (url !== 'ClientSide' || url === 'ClientSide' && mixPanelEventConstants.CliendSideError) {
                // mixpanel.track(`Errors` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
                //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                //   'date': new Date(),
                //   'path': `${window.location.href}`,
                //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}`,
                //   'url': relativeUrl ?? "",
                //   [`${url.includes(envConfig().baseURL) ? 'error' : 'validation'} Message`]: msg,
                //   'request': _request || "",
                // });
            }
        }
    }
};
export var GoogleAnlyticsAPICallsTimeLog = function (profileData, response, request) {
    var _response$config;
    var endTime = new Date();
    var startTime = response.config.metadata.startTime;
    var responseTime = endTime - startTime; // Calculate response time in milliseconds
    var relativeUrl = (_response$config = response.config) === null || _response$config === void 0 || (_response$config = _response$config.url) === null || _response$config === void 0 ? void 0 : _response$config.replace(envConfig().baseURL, '');
    var _request = request && JSON.parse(JSON.stringify(request));
    var time1InMs = parseTime(formatResponseTime(responseTime));
    var time2InMs = parseTime("0m 5s 0ms");
    if (Analytics.MixPanel) {
        if (mixPanelEventConstants.APICallEvents && (mixPanelEventConstants.APICallGreaterThan5mb ? true : time1InMs >= time2InMs)) {
            // mixpanel.track(`API Calls` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
            //   'id': profileData?.data?.IdentityId,          // Transaction ID.
            //   'date': new Date(),
            //   'path': `${window.location.href}`,
            //   'url': relativeUrl,
            //   'response Time': formatResponseTime(responseTime),
            //   'request': _request || ''
            // });
        }
    }
    if (Analytics.GA) {
        var _profileData$data5, _profileData$data6, _profileData$data7, _profileData$data8, _profileData$data9, _profileData$data10;
        window.gtag('event', "API Calls" + " ".concat(profileData === null || profileData === void 0 || (_profileData$data5 = profileData.data) === null || _profileData$data5 === void 0 ? void 0 : _profileData$data5.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data6 = profileData.data) === null || _profileData$data6 === void 0 ? void 0 : _profileData$data6.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data7 = profileData.data) === null || _profileData$data7 === void 0 ? void 0 : _profileData$data7.IdentityId), {
            'id': profileData === null || profileData === void 0 || (_profileData$data8 = profileData.data) === null || _profileData$data8 === void 0 ? void 0 : _profileData$data8.IdentityId,
            // Transaction ID.
            'date': new Date(),
            'path': "".concat(window.location.href),
            'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data9 = profileData.data) === null || _profileData$data9 === void 0 ? void 0 : _profileData$data9.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data10 = profileData.data) === null || _profileData$data10 === void 0 ? void 0 : _profileData$data10.FamilyName),
            'url': relativeUrl,
            'response Time': formatResponseTime(responseTime)
        });
    }
};
export var transactionEventLog = function (eventName, eventProp, profileData) {
    if (Analytics.GA) {
        window.gtag('event', eventName, eventProp);
    }
    if (Analytics.MixPanel) {
        // mixpanel.track(eventName + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, eventProp);
    }
};
export var formDateFormate = function (date) {
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var objectDate = new Date(date);
    var d = objectDate.getDate();
    var month = monthNames[objectDate.getMonth()];
    var y = objectDate.getFullYear();
    var dd = d < 10 ? "0".concat(d) : d;
    return "".concat(month, " ").concat(dd, ", ").concat(y);
};
export var getMobileNumber = function (personContactPoint, contactType) {
    if (contactType === EContactType.Primary)
        return personContactPoint === null || personContactPoint === void 0 ? void 0 : personContactPoint.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ContactType) === contactType; });
    if (contactType === EContactType.Secondary)
        return personContactPoint === null || personContactPoint === void 0 ? void 0 : personContactPoint.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ContactType) === contactType; });
};
export var detectPlatform = function () {
    if (Capacitor.isNativePlatform()) {
        return Capacitor.getPlatform(); // Returns "android" or "ios"
    }
    else {
        return "web";
    }
};
export var forceRefresh = function () {
    if (!sessionStorage.getItem('hasReloaded')) {
        sessionStorage.setItem('hasReloaded', 'true');
        var currentUrl = window.location.href.split('?')[0];
        window.location.href = "".concat(currentUrl, "?_=").concat(new Date().getTime());
    }
};
export var validateFilterDuration = function (startDate, endDate) {
    var DateRange = getLocalStorageItem(LOCAL_STORAGE_KEYS.DATE_FILTER_RESTRICTION);
    var duration = DateRange && DateRange !== null && DateRange !== void 0 && DateRange.Value ? DateRange === null || DateRange === void 0 ? void 0 : DateRange.Value : maxDays;
    if (startDate && endDate) {
        var _dayjs;
        var daysDifference = startDate && endDate ? (_dayjs = dayjs(endDate)) === null || _dayjs === void 0 ? void 0 : _dayjs.diff(startDate, "days") : 0;
        return daysDifference <= Number(duration);
    }
    return false;
};
export function isExeOrJsFile(buffer) {
    // Check if buffer is large enough for an EXE file
    if (buffer.length >= 64) {
        // Check "MZ" signature at the start
        if (buffer[0] === 0x4D && buffer[1] === 0x5A) {
            // Read PE header offset (4-byte little-endian integer at offset 0x3C)
            var peOffset = buffer.readUInt32LE(0x3C);
            // Validate PE offset (ensure enough space for PE signature and FileHeader)
            if (peOffset <= buffer.length - 24) {
                // Check "PE\0\0" signature at peOffset
                if (buffer[peOffset] === 0x50 && buffer[peOffset + 1] === 0x45 && buffer[peOffset + 2] === 0x00 && buffer[peOffset + 3] === 0x00) {
                    // Read Characteristics field (2-byte little-endian word at peOffset + 4 + 18)
                    var characteristics = buffer.readUInt16LE(peOffset + 4 + 18);
                    // Check if IMAGE_FILE_DLL flag (0x2000) is set; if not, it's an .exe
                    if (!(characteristics & 0x2000)) {
                        return true;
                    }
                }
            }
        }
    }
    // Convert buffer to string (assuming UTF-8 encoding)
    var content = buffer.toString('utf-8').trim();
    // Check for JavaScript keywords or patterns
    var jsPatterns = [/\bfunction\b/,
        // Function declarations
        /\bvar\b/,
        // Variable declarations
        /\bconst\b/,
        // Constant variable declarations
        /\blet\b/,
        // Block-scoped variables
        /\bimport\b/,
        // ES6 module import
        /\bexport\b/,
        // ES6 module export
        /\bconsole\b/ // Common debugging/logging function
    ];
    if (jsPatterns.some(function (pattern) { return pattern.test(content); })) {
        return true;
    }
    return false;
}
export function convertNumberToDecimal(number) {
    var decimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    return (number ? Number(number) : 0).toFixed(decimal);
}
export var createUILog = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Post(createUILogURL, request)];
            case 1:
                response = _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var getCurrentWeekRange = function () {
    var now = new Date();
    var day = now.getDay(); // 0 = Sunday, 6 = Saturday
    // Sunday start (local midnight)
    var sunday = new Date(now);
    sunday.setDate(now.getDate() - day);
    sunday.setHours(0, 0, 0, 0);
    // Saturday end (local 23:59:59.999)
    var saturday = new Date(sunday);
    saturday.setDate(sunday.getDate() + 6);
    saturday.setHours(23, 59, 59, 999);
    return {
        from: sunday.toISOString(),
        to: saturday.toISOString()
    };
};
export var formatDuration = function (seconds) {
    var min = Math.floor(seconds / 60);
    var sec = seconds % 60;
    if (min > 0 && sec > 0)
        return "".concat(min, "min ").concat(sec, "sec");
    if (min > 0)
        return "".concat(min, "min");
    return "".concat(sec, "sec");
};
export var startCountdown = function (totalSeconds) {
    var seconds = totalSeconds;
    var timer = setInterval(function () {
        seconds--;
        if (seconds < 0) {
            clearInterval(timer);
        }
    }, 1000);
};
